import { render, staticRenderFns } from "./mails.vue?vue&type=template&id=463f1a6a&"
import script from "./mails.vue?vue&type=script&lang=js&"
export * from "./mails.vue?vue&type=script&lang=js&"
import style0 from "./mails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports